import * as Sentry from '@sentry/vue'

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const {
    public: { sentry, serverUrl },
  } = useRuntimeConfig()

  if (!sentry.dsn || sentry.environment === 'development') {
    return
  }

  Sentry.init({
    app: nuxtApp.vueApp,
    environment: sentry.environment,
    release: sentry.release,
    dsn: sentry.dsn,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', serverUrl],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend(event) {
      // App state at capture time, attached to every event — distinguishes
      // real failures from offline users, background tabs, and long-lived
      // sessions running a stale release (the usual cause of "Failed to
      // fetch" on lazy-loaded chunks after a deploy).
      event.contexts = {
        ...event.contexts,
        'App State': {
          online: navigator.onLine,
          visibility: document.visibilityState,
          path: window.location.pathname,
          minutesSincePageLoad: Math.round(performance.now() / 60_000),
        },
      }
      event.tags = {
        'net.online': String(navigator.onLine),
        ...event.tags,
      }
      return event
    },
  })
})
